import React, { useState, useEffect } from 'react'
import {
  node, bool, func, string,
} from 'prop-types'
import Modal from 'react-modal'
import styled from '@emotion/styled'
import RouteModalImage from 'assets/route-modal-image.png'
import InputTextField from 'components/input-text-field'
import Button from 'components/button'
import api from 'api'
import X from '../x-svg'
import './download-modal.css'

const styles = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.15)',
  },
}

const ModalDiv = styled.div`
  position: relative;
  overflow-y: scroll;
  max-height: 100%;
  ::-webkit-scrollbar {
    width: 0px;
    background: transparent; /* make scrollbar transparent */
  }
`
const Close = styled.div`
  cursor: pointer;
  border-radius: 50%;
  position: absolute;
  padding: 7px 6px 0px 6px;
  top: 12px;
  right: 12px;
  :hover {
    background: #023646;
  }
`

const Main = styled.p`
  margin-top: -8px;
  z-index: 100;
  color: white;
  font-weight: bold;
  font-size: 34px;
  text-align: center;
`

const Subtitle = styled.p`
  margin-top: -24px;
  color: white;
  font-size: 18px;
  text-align: center;
  padding: 0 48px;
`

const InlineFlex = styled.div`
  margin-top: 16px;
  display: flex-inline;
  max-width: 360px;
  margin-left: auto;
  margin-right: auto;
`

const MarginLeftButton = styled(Button)`
  margin-top: 8px;
  margin-left: 12px;
`
const SubText = styled.p`
  margin-top: 24px;
  font-size: 12px;
  color: #999999;
  text-align: center;
`

const Image = styled.img`
  margin-left: auto;
  margin-right: auto;
  display: block;

  @media (max-width: 600px) {
    max-width: 100%;
  }
`
const TextField = styled(InputTextField)`
  margin-top: 8px;
`

const DownloadModal = ({
  isOpen, close, contentLabel, element,
}) => {
  const [phoneNumber, setPhoneNumber] = useState('')
  const isPhoneNumber = phoneNumber.match(/^\d{10}$/)
  useEffect(() => {
    const img = document.createElement('img')
    img.src = RouteModalImage
  })

  if (element) {
    Modal.setAppElement(element)
  }

  return (
    <Modal
      closeTimeoutMS={250}
      style={styles}
      className="download-modal"
      isOpen={isOpen}
      onRequestClose={close}
      contentLabel={contentLabel}
      ariaHideApp={false}
    >
      <ModalDiv>
        <Close onClick={close}>
          <X />
        </Close>
        <Image src={RouteModalImage} alt="route-modal" />
        <Main>One app for everything you buy</Main>
        <Subtitle>
          Track everything you buy from checkout to delivery. Discover new products, brands and
          trends– all in one app.
        </Subtitle>
        <InlineFlex>
          <TextField
            fullWidth
            placeholder="Phone Number"
            onChange={(e) => setPhoneNumber(e.target.value)}
          />
          <MarginLeftButton
            disabled={!isPhoneNumber}
            onClick={() => api.sms.sendSMS(phoneNumber).then(close)}
          >
            Send Link
          </MarginLeftButton>
        </InlineFlex>
        <SubText>
          We won&apos;t use your phone number for anything else. Standard text messaging rates may
          apply.
        </SubText>
      </ModalDiv>
    </Modal>
  )
}

DownloadModal.propTypes = {
  isOpen: bool,
  close: func.isRequired,
  contentLabel: string,
  element: node,
}

DownloadModal.defaultProps = {
  isOpen: false,
  contentLabel: '',
  element: null,
}

export default DownloadModal
